import React, { Component } from "react";
import "./Join.css";
import axios from "axios";
import spatiam_logo from "../assets/spatiam_logo_white.png";
import login_image from "../assets/manager_graphic17.png";
import { Link } from "react-router-dom";

class Join extends Component {
  state = {
    credentials: { first_name: "", last_name: "", email: "" },
    validationErrors: [],
    modal: true,
    registered: false,
    success_request: "",
    loading: false,
    errors: [],
  };

  setRegistered = (isRegistered) => {
    this.setState({ registered: isRegistered });
  };

  getRegistered = () => {
    return this.state.registered;
  };

  toggle = () => {
    this.setState({ modal: !this.state.modal });
  };

  request_access = async () => {
    this.setState({ loading: true });
    const cred = {};
    cred["first_name"] = "";
    cred["last_name"] = "";
    cred["email"] = "";

    let validated = true;
    for (var [key, value] of Object.entries(this.state.credentials)) {
      if (value === "") {
        switch (key) {
          case "first_name":
            cred[key] = "Enter first name";
            break;
          case "last_name":
            cred[key] = "Enter last name";
            break;
          default:
            cred[key] = "Enter email";
        }

        await this.setState({ validationErrors: cred });
        validated = false;
      } else if (key === "email" && !this.validateEmail(value)) {
        cred[key] = "Enter a valid email address";
        await this.setState({ validationErrors: cred });
        validated = false;
      }
    }

    if (!validated) {
      this.renderErrors();
      this.setState({ loading: false });
      return;
    }

    axios
      .post(
        this.props.baseUrl + "/api/api/potentialuser/",
        this.state.credentials
      )
      .then((response) => {
        this.setState({ success_request: true });
        this.setState({ errors: [] });
        this.setState({ loading: false });
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
        this.renderErrors();
        this.setState({ loading: false });
      });
    return;
  };

  validateEmail = (mail) => {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        mail
      )
    ) {
      return true;
    }
    return false;
  };

  inputChanged = (event) => {
    const cred = this.state.credentials;
    cred[event.target.name] = event.target.value;
    this.setState({ credentials: cred });
    this.setState({ success_request: false });
    this.setState({ loading: false });
  };

  renderErrors = () => {
    const validationErrors = this.state.validationErrors;
    const error_tags = ["first_name", "last_name", "non_field_errors", "email"];
    let errors = [];

    var arrayLength = error_tags.length;
    for (var i = 0; i < arrayLength; i++) {
      const error_tag = error_tags[i];
      const error_msg = validationErrors[error_tag];
      if (error_msg) {
        errors.push(<li key={error_tags[i]}>{error_msg}</li>);
      }
    }

    this.setState({ errors: errors });
    return;
  };

  render() {
    return (
      <div className="login">
        <div className="login_page">
          <a href="https://www.spatiam.com/">
            <img className="logo_image" src={spatiam_logo} alt="logo" />
          </a>
          <div className="login_area">
            <div className="input_area">
              <div className="input_area">
                <div className="title_area">
                  <h1>Join the Beta</h1>
                </div>
                <label>
                  Spatiam Corporation's <b>ION-DTN Management Tool</b> is
                  currently in beta phase.
                  <br />
                  <br />
                  If you wish to join, enter your information to receive a
                  registration key once approved:
                </label>
                <div className="input_area">
                  <div className="name_area">
                    <label>
                      First Name:
                      <br />
                      <input
                        type="text"
                        name="first_name"
                        value={this.state.credentials.first_name}
                        onChange={this.inputChanged}
                        maxLength="100"
                      />
                    </label>
                    <label>
                      Last Name:
                      <br />
                      <input
                        type="text"
                        name="last_name"
                        value={this.state.credentials.last_name}
                        onChange={this.inputChanged}
                        maxLength="100"
                      />
                    </label>
                  </div>
                  <label>
                    Email:
                    <br />
                    <input
                      type="text"
                      name="email"
                      value={this.state.credentials.email}
                      onChange={this.inputChanged}
                      maxLength="320"
                    />
                  </label>

                  <button
                    className="login_button"
                    disabled={this.state.loading || this.state.success_request}
                    onClick={() => {
                      this.request_access();
                    }}
                  >
                    {this.state.loading
                      ? "Loading, this could take some time..."
                      : this.state.success_request
                      ? "Request successfully submitted"
                      : "Submit Request"}
                  </button>
                  <ul style={{ color: "red", marginTop: "10px" }}>
                    {this.state.errors}
                  </ul>
                  <p style={{ color: "green", marginTop: "10px" }}>
                    {this.state.success_request ? "Success! An email confirmation will be sent, please check your Junk folder." : ""}
                  </p>
                </div>
              </div>
              <div>
                <Link to={this.props.baseDir}>{"< Back"}</Link>
              </div>
            </div>
            <div className="image_area">
              <img
                className="login_image"
                src={login_image}
                alt="Manage Your DTN Networks"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Join;
